import { atom } from "jotai";

export const isOfflineAtom = atom(false);
export const isStreamingAtom = atom(false);
export const isGeneratingAtom = atom(false);
export const isEditingAtom = atom(false);


export const sidebarCollapsedAtom = atom<boolean>(false);

export const isChatOpenAtom = atom<boolean>(false);

// Page type for Document/Video/Workflow switch
export const pageTypeAtom = atom<'docs' | 'video' | 'workflow'>('docs');

// Workflow page entry action: when set to 'create', WorkflowPage will auto-start compilation once and then reset
export const workflowActionAtom = atom<'create' | null>(null);

// Video dialog state
export const showVideoDialogAtom = atom<boolean>(false);
